import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) => ({
    titlePage: {
        padding: '1.5vh 0',
        fontSize: 20,
        fontWeight: 600,
        color: '#2B56A5',
        textAlign: "center",
        borderBottom: '1px solid',
        backgroundColor: '#e8eef4',
        [theme.breakpoints.down('sm')]: {
            fontSize: 15,
        },
    },
    border: {
        border: '1px solid',
    },
    content: {
        width: '90%',
        margin: '1.5vh auto',
    },
    contentArray: {
        borderBottom: '1px solid',
    }
}));
